import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { useToast } from "../components/Toast";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLoginPage() {
  const { login, user } = useAuth();
  const { t } = useLang();
  const { push: toast } = useToast();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    nav("/admin");
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast(formatApiErrorDetail(err.response?.data?.detail) || "Login failed", "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="pt-28 md:pt-32 pb-20 px-5 md:px-10 max-w-md mx-auto" data-testid="admin-login-page">
      <h1 className="font-serif text-5xl mb-8">{t("admin_login")}</h1>
      <form onSubmit={submit} className="card p-8 space-y-6">
        <div>
          <label className="block text-xs tracking-widest uppercase opacity-60 mb-1">{t("email")}</label>
          <input
            type="email"
            className="input-line"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="admin-email"
          />
        </div>
        <div>
          <label className="block text-xs tracking-widest uppercase opacity-60 mb-1">{t("password")}</label>
          <input
            type="password"
            className="input-line"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="admin-password"
          />
        </div>
        <button className="btn btn-primary w-full" disabled={busy} data-testid="admin-login-btn">
          {t("login")}
        </button>
      </form>
    </section>
  );
}
